<template>
  <div ref="track" class="range track" :class="classes" @click="onClickTrack">
    <div
      class="mark"
      v-for="(item, i) in marks"
      :key="i"
      :style="{ left: item.pos * 100 + '%' }"
    >
      <div class="text" v-if="i % 2 === 0">{{ item.text }}</div>
    </div>
    <div class="bar" :style="{ width: `${currentPos * 100}%` }"></div>
    <div
      class="thumb"
      :class="{ active: isMoving }"
      :style="{ left: `${currentPos * 100}%` }"
      :draggable="false"
      @mousedown.stop.prevent="startMove"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    classes: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      trackStart: 0,
      trackSize: 0,
      isMoving: false,
      marks: []
    };
  },
  computed: {
    currentPos () {
      return (this.value - this.min) / (this.max - this.min);
    },
  },
  mounted () {
    this.initPos();
    window.addEventListener('resize', this.initPos);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.initPos);
  },
  methods: {
    initPos () {
      let rect = this.$refs.track.getBoundingClientRect();
      this.trackStart = rect.left;
      this.trackSize = rect.width;
      this.makeMarks();
    },
    startMove () {
      this.initPos();
      this.isMoving = true;
      this.$emit('startMove');
      window.addEventListener('mousemove', this.moving);
      window.addEventListener('mouseup', this.endMove);
    },
    moving (e) {
      this.updateValue(e.clientX);
    },
    endMove (e) {
      // let value = this.updateValue(e.clientX);
      // let remain = value % this.step;
      window.removeEventListener('mousemove', this.moving);
      window.removeEventListener('mouseup', this.endMove);
      this.isMoving = false;
    },
    updateValue (axis) {
      let progress = axis - this.trackStart;
      progress = progress / this.trackSize;
      let value = progress * (this.max - this.min) + this.min;
      if (this.step) {
        value = Math.round(value / this.step) * this.step + this.min;
        value = value.toFixed(1) - 0;
      }
      value = Math.max(Math.min(value, this.max), this.min);
      this.$emit('input', value);
      return value;
    },
    onClickTrack (e) {
      this.updateValue(e.clientX);
    },
    makeMarks () {
      let totalSteps = (this.max - this.min) / this.step;
      let texts = '慢 0 稍慢 0 正 0 稍快 0 快'.split(' ');
      let stepSize = this.trackSize / totalSteps;
      let marks = [];
      for (let i = 0; i <= totalSteps; i++) {
        marks.push({
          pos: Math.min(i * stepSize / this.trackSize, 1),
          text: texts[i]
        });
      }
      this.marks = marks;
    }
  }
};
</script>

<style lang="scss" scoped>
.track {
  position: relative;
  width: 174px;
  height: 4px;
  background: #e7e7fb;
  border-radius: 5px;
}
.bar {
  width: 0;
  height: 4px;
  background: #e7e7fb;
  border-radius: 5px;
}
.thumb {
  $thumb-width: 12px;
  $thumb-height: $thumb-width;
  $track-width: 4px;
  position: absolute;
  top: 0;
  left: 0;
  margin-top: -($thumb-height - $track-width) / 2;
  margin-left: -$thumb-width / 2;
  width: $thumb-width;
  height: $thumb-height;
  background: #737596;
  border-radius: 50%;
  user-select: none;
  cursor: grab;
  transition-property: transform;
  transition-duration: 0.3s;
}
.mark {
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  background: #ced0eb;
  border-radius: 50%;
  margin-top: -3px;
  margin-left: -5px;
  & > .text {
    position: absolute;
    bottom: 120%;
    left: 50%;
    transform: translatex(-50%);
    font-size: 12px;
    min-width: 24px;
    color: #9f9caf;
    white-space: nowrap;
    text-align: center;
  }
}
.small {
  &.track {
    width: 156px;
  }
  & .thumb {
    $thumb-width: 10px;
    $thumb-height: $thumb-width;
    $track-width: 4px;
    margin-top: -($thumb-height - $track-width) / 2;
    margin-left: -$thumb-width / 2;
    width: $thumb-width;
    height: $thumb-height;
  }
  & .mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 8px;
    height: 8px;
    background: #ced0eb;
    border-radius: 50%;
    margin-top: -2px;
    margin-left: -4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dialogs/smartVoice/range.vue